import {Component, OnInit, Output, Input, EventEmitter} from '@angular/core';

@Component({

    selector: 'profile-change-email',
    template: require('./profile-change-email.component.html')    

})

export class SuperUserProfileChangeEmailComponent implements OnInit {
                
    @Input('invalidEmail') wrongEmailChange: boolean;    
    @Input('invalidEmailLength') wrongEmailLength: boolean;
    @Input('invalidEmailExists') wrongEmailExists: boolean;
    @Output() userEmail = new EventEmitter();        
    email: String;

    constructor() {
                        
        this.email = "";

    }

    ngOnInit() {

    }

    ngDoCheck() {

        this.userEmail.emit ({

            value: this.email

        })

    }

    goBack() {

        window.history.back();
        
    }

}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/super_user/profile/profile_change_email/profile-change-email.component.ts
 **/